<script lang="ts">
  import { store } from '../lib/store.svelte.ts';
  import { router } from '../lib/router.svelte.ts';

  let creating = $state(false);
  let newName = $state('');
  let busy = $state(false);
  let error = $state<string | null>(null);

  async function create() {
    busy = true;
    error = null;
    try {
      await store.createSite(newName.trim());
      creating = false;
      newName = '';
    } catch (e) {
      error = e instanceof Error ? e.message : String(e);
    } finally {
      busy = false;
    }
  }
</script>

<div class="row" style="margin-bottom:.5rem">
  <h1 class="grow">Sites</h1>
  {#if store.isAdmin}
    <button class="primary slim" onclick={() => (creating = true)}>Ajouter</button>
  {/if}
</div>

<div class="card row wrap tiny muted">
  <span class="grow">{store.sites.length} site(s)</span>
  <a href="/api/export/sites.csv">Export CSV</a>
</div>

{#if store.sites.length === 0}
  <div class="card"><p class="empty">Aucun site. Créez-en un pour pouvoir démarrer une tournée.</p></div>
{:else}
  <ul class="list card">
    {#each store.sites as s (s.code)}
      <li>
        <button class="row-link" onclick={() => router.go(`sites/${s.code}`)}>
          <span class="stack" style="gap:.1rem;align-items:flex-start">
            <span class="truncate row-title">{s.name}</span>
            <span class="mono tiny muted">{s.code}</span>
          </span>
        </button>
        <span class="pill">{store.cartsAt(s.code).length} chariots</span>
        {#if s.status !== 'active'}<span class="pill warn">archivé</span>{/if}
      </li>
    {/each}
  </ul>
{/if}

{#if error}<div class="banner danger">{error}</div>{/if}

{#if creating}
  <div class="overlay" role="dialog" aria-modal="true" aria-label="Ajouter un site">
    <div class="sheet">
      <h2>Ajouter un site</h2>
      <label class="field"><span>Nom du site</span><input bind:value={newName} placeholder="Entrepôt Nord" /></label>
      <div class="row">
        <button class="primary grow" onclick={create} disabled={busy || !newName.trim()}>
          {#if busy}<span class="spinner"></span>{/if} Créer
        </button>
        <button class="ghost" onclick={() => (creating = false)}>Annuler</button>
      </div>
    </div>
  </div>
{/if}
